export default {"cluster":"baseddb","org":"crowdbuilding","env":"production","project":"platform"};